export default function SET_CANDIDATE(state, candidateData) {
    state.candidate = candidateData;
}